import React from 'react'
import Route from 'route-parser'
import TableWrapper from 'pages/mwdealcompare/TableWrapper'
import { LayoutMain, LayoutHeader, HeaderAction, LayoutHistoryBack } from 'components/dealwatch/Layout'
import { COMPARISON_PROPS_LIMIT } from 'constants/mw-comparison-limits'
import { URL_DOWNLOAD_DEAL_COMPARISON_EXCEL } from 'constants/urls'

const Main = ({ deals, short, query, comparableParams, compareParams }) => {
  const hasParamsSelected = compareParams.length > 0
  const downloadUrl = new Route(URL_DOWNLOAD_DEAL_COMPARISON_EXCEL).reverse({
    deals: deals.map(({ dealId }) => dealId),
    parameters: compareParams
  })

  return (
    <div className='layout-width-constraint deal-watch-width-constraint'>
      <LayoutHistoryBack />
      <LayoutHeader title='Comparing Deals' cxNames='mt8 mh2'>
        {hasParamsSelected && (
          <HeaderAction
            icon='icon-download'
            description='Download in Excel'
            href={downloadUrl}
          />
        )}
      </LayoutHeader>
      {hasParamsSelected
        ? (
          <div className='mt0'>
            <TableWrapper {...{ deals, short, query, compareParams, comparableParams }} />
          </div>
          )
        : (
          <LayoutMain className='tc mv2 mhauto i dim-grey f4'>
            Please select the parameters you want to compare on the left-hand
            side. You can choose up to {COMPARISON_PROPS_LIMIT} parameters.
          </LayoutMain>
          )}
    </div>
  )
}

export default Main
